import { Download } from 'lucide-react';
import { useBrochure } from '../hooks/useBrochure';

// Varianten:
// - secondary:     blauwe outline-knop, voor witte/grijze achtergronden
// - white:         witte knop op blauw, naast een rode btn-primary (zoals de hero op home)
// - outline-white: witte outline-knop op blauw, naast een witte hoofdknop
// - link / link-white: tekstlink als 3e optie, naast twee bestaande knoppen
type Variant = 'secondary' | 'white' | 'outline-white' | 'link' | 'link-white';

const VARIANT_CLASSES: Record<Variant, string> = {
  secondary: 'btn-secondary justify-center',
  white:
    'inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-medium whitespace-nowrap bg-white text-[#0284c7] hover:bg-gray-100 transition-colors',
  'outline-white':
    'inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold whitespace-nowrap border-2 border-white/80 text-white hover:bg-white/10 transition-colors',
  link: 'inline-flex items-center gap-2 font-medium text-[#0284c7] underline underline-offset-4 decoration-[#0284c7]/30 hover:decoration-[#0284c7]',
  'link-white':
    'inline-flex items-center gap-2 font-medium text-white underline underline-offset-4 decoration-white/40 hover:decoration-white',
};

export function BrochureButton({
  variant = 'secondary',
  label = 'Download onze brochure',
  className = '',
}: {
  variant?: Variant;
  label?: string;
  className?: string;
}) {
  const { openBrochure } = useBrochure();
  return (
    <button
      type="button"
      onClick={openBrochure}
      className={`${VARIANT_CLASSES[variant]} ${className}`.trim()}
    >
      <Download className="w-4 h-4" aria-hidden="true" />
      {label}
    </button>
  );
}
